'use client';

// Error components must be Client Components
import { useEffect } from 'react';

// https://nextjs.org/docs/app/building-your-application/routing/error-handling
export default function ErrorView({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div>
      <h2>Something went wrong!</h2>
      <button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
        type="button"
      >
        Try again
      </button>
    </div>
  );
}
